module.exports = __webpack_public_path__ + "static/img/comment_face_1.f255ac83.png";